import * as React from "react";
import {authorize} from "@athena-portal/components";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {Link} from "react-router-dom";
import {
    Policy, productHelper,
    ProductsEnum,
    Quote,
    resourcesHelper,
    Subscription
} from "@falcon/services";
import {
    Detail,
    DetailKey,
    DetailValue
} from "@falcon/plugin-falcon-journey";
import {formatDateDMY, getAddress, getAmountToDisplay, getAmountWithDecimalDigits} from "../../../../CommonFunctions";
import {PageTitle} from "../../../../components/navigation/PageTitle";


interface IProps {
    quotes?: Quote[];
    policies?: Policy[];
    isActivePoliciesPresent: boolean;
    subscription?: Subscription;
}

@authorize
export class HomeInsuranceQuotesPanel extends React.Component<IProps> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <React.Fragment>

                {this.renderQuotes()}
            </React.Fragment>
        );
    }

    private renderQuotes(): JSX.Element[] | JSX.Element {
        const homeInsuranceQuotes: any = [];

        // Filter quotes which don't have UW and are not from aggregator.
        const filteredQuotes = this.props.quotes &&
            this.props.quotes.filter(quote => {
                return !(
                    Array.isArray(quote.interaction.underwritingResult) &&
                    quote.interaction.underwritingResult.length > 0 &&
                    quote.interaction.source === null
                )
            });

        if (filteredQuotes && filteredQuotes.length !== 0) {
            filteredQuotes.sort((a,b) => a.interaction.createdOn > b.interaction.createdOn ? -1 : 1).forEach(
                quote => {
                    const summary: string = "summary";
                    let process: string = this.props.isActivePoliciesPresent ? quote.interaction.process + "/" + summary : "nb/summary";

                    if (quote.interaction.realEstate && quote.interaction.realEstate.length !== 0 ) {
                        process = quote.interaction.process + "/" + "quote";

                        const homeInsuranceQuoteLink: string = this.getViewAndEditDetailsLink(ProductsEnum.HOME, process, quote);

                        this.setQuotesContent(quote, homeInsuranceQuotes, homeInsuranceQuoteLink);

                    }
                }
            );
            return (
                <div>
                    {(homeInsuranceQuotes && homeInsuranceQuotes.length > 0) && (
                        <div className="journey-content your-annual-quotes-page">
                            <div className="journey-questions">
                                {this.pluginTemplates.renderBackLink("Back", true, this.getBackLink())}

                                <PageTitle title={`Your home insurance quotes`}
                                           className={"text-group title plugin no-indent-desktop"}/>

                                {homeInsuranceQuotes}
                                {this.pluginTemplates.renderBackLink("Back", false, this.getBackLink())}
                            </div>
                        </div>
                    )}
                </div>
            )
        } else {
            return (
                <div className="journey-content">
                    <div className="journey-questions plugin">
                        {this.pluginTemplates.renderBackLink("Back", true, this.getBackLink())}
                        <PageTitle title={`Your home insurance quotes`}
                                   className={"text-group title plugin no-indent-desktop"}/>
                        <div className="quote quote-summary-panel plugin text-center mb-4 mt-4">
                            <p>You don’t have any active quotes saved</p>
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, this.getBackLink())}
                </div>
            )
        }
    }

    private getViewAndEditDetailsLink = (product: string, process: string, quote: Quote): string => {
        return "/journey/show/product/" + product + "/process/" + process + "/" + quote.interaction._id + "?auth";
    }

    private setQuotesContent = (quote: Quote, productQuotes: any[], viewAndEditLink: string): void => {

        let quoteCover = quote.interaction.covers.filter((cover: any) => cover.type === "BUILDINGS_CONTENTS")[0];

        let buildingsLimitCoverAmount = this.getLimitAmount(quoteCover, "BUILDINGS_LIMIT");
        let contentsLimitCoverAmount = this.getLimitAmount(quoteCover, "CONTENTS_LIMIT");

        const paymentEligibilty: string = quote.interaction.radarPolicyData.instalmentAllowedStatus;
        const monthlyAvailable: boolean = paymentEligibilty === "A";

        productQuotes.push(

            <div className="section-panel your-cover-panel position-relative"
                 key={quote.interaction._id}>

                <img className="home-icon"
                     src={`/${resourcesHelper.THEME}/img/home-icon.png`}
                     alt="Home icon"/>

                <div className="section">
                    <div className="adress-plus-price">

                        <h2 className="address-title-calc mt-4 mb-3 section-heading">
                            {getAddress(quote.interaction.realEstate[0]?.address)} {quote.interaction.realEstate[0]?.address?.postcode}
                        </h2>

                        <Detail className="price-section position-absolute top-right-price">
                            <div className="detail-value price justify-content-end">
                                <span className="font-weight-bold">Price</span>
                                <div>
                                    <span className="amount">{getAmountToDisplay(quote.interaction.factors.annualPremium)}</span>
                                    <span className="year"> / year*</span>
                                </div>
                            </div>
                        </Detail>

                    </div>

                    <div className="section-contents">

                        <Detail>
                            <DetailKey>
                                Buildings cover:
                            </DetailKey>
                            <DetailValue>
                                {this.renderCoverAmounts(buildingsLimitCoverAmount)}
                            </DetailValue>
                        </Detail>
                        <Detail className="mt-1">
                            <DetailKey>
                                Contents cover:
                            </DetailKey>
                            <DetailValue>
                                {this.renderCoverAmounts(contentsLimitCoverAmount)}
                            </DetailValue>
                        </Detail>

                        <Detail>
                            <DetailKey>
                                Quote created on:
                            </DetailKey>
                            <DetailValue>
                                {formatDateDMY(quote.interaction.createdOn)}
                            </DetailValue>
                        </Detail>

                        {monthlyAvailable && <Detail>
                            <DetailKey>
                                Monthly:
                            </DetailKey>
                            <DetailValue>
                                {getAmountToDisplay(quote.interaction.factors.monthlyPremium)}
                            </DetailValue>
                        </Detail>}
                        {monthlyAvailable && <Detail className="mt-1">
                            <DetailValue>
                                {this.renderPriceTotal(quote.interaction.paymentDetails.instalmentPlan.totalAmount)}
                            </DetailValue>
                        </Detail>}
                        {monthlyAvailable && <Detail className="mt-1">
                            <DetailValue>
                                {this.renderMonthlyDifference(quote.interaction)}
                            </DetailValue>
                        </Detail>}

                        <Detail className="mt-1">
                            <DetailValue>
                                All figures include interest change and insurance premium tax
                            </DetailValue>
                        </Detail>

                        <Detail>
                            <DetailKey>
                                Start date:
                            </DetailKey>
                            <DetailValue>
                                {formatDateDMY(quote.interaction.headerInfo.startDate)}
                            </DetailValue>
                        </Detail>

                        <Link
                            to={viewAndEditLink}
                            className="inner-content buttonLink"
                            id={"viewAndEditQuote" + quote.quoteId}>
                            <button type="button" className="btn btn-primary plugin">View and edit details
                            </button>
                        </Link>

                        <p>
                            * All figures include insurance premium tax
                        </p>

                    </div>
                </div>

            </div>
        );
    }

    private getLimitAmount(cover: any, limit: string) {
        return cover.amounts?.filter((amount: any) => amount.type === limit)[0]?.amount;
    }

    private renderCoverAmounts(amount: any): string {
        return "up to " + getAmountToDisplay(amount);
    }

    private renderPriceTotal(amount: any): string {
        return getAmountToDisplay(amount) + " in total";
    }

    private renderMonthlyDifference(interaction: any): string {
        const amountDifference: number = interaction.paymentDetails.instalmentPlan.totalAmount - interaction.factors.annualPremium;
        return getAmountWithDecimalDigits(amountDifference) + " more expensive to pay monthly";
    }

    private getBackLink(): string {
        let onlySubscriptionProduct: boolean = false;

        if (this.props.policies) {
            onlySubscriptionProduct = productHelper.includesOnlyNonExpireMonthlySubscriptionProduct(this.props.policies);
        }

        if (onlySubscriptionProduct) {
            return "/dashboard/monthlySubscription";
        } else if (this.props.isActivePoliciesPresent && !onlySubscriptionProduct) {
            return "/dashboard/getNewQuote";
        } else {
            return "/dashboard/viewOrGetQuotes";
        }

    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/quotesPage/HomeInsuranceQuotesPanel.tsx